// ═══════════════════════════════════════════════════════════════
// FRONTEND API SERVICE: Beneficios Fiscales (ISR - DGII RD)
// Path: src/api/taxBenefits.js
// ═══════════════════════════════════════════════════════════════

import apiConfig from './config';

const API_BASE = '/tax-benefits';

/** Lista beneficios de la compañía. Acepta filtros opcionales. */
export const getTaxBenefits = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.employeeId)  params.append('employeeId',  filters.employeeId);
  if (filters.benefitType) params.append('benefitType', filters.benefitType);
  if (filters.fiscalYear)  params.append('fiscalYear',  filters.fiscalYear);
  if (filters.status)      params.append('status',      filters.status);
  const qs = params.toString();
  const response = await apiConfig.get(`${API_BASE}${qs ? `?${qs}` : ''}`);
  return response.data;
};

/** Beneficios de un empleado específico (historial completo). */
export const getTaxBenefitsByEmployee = async (employeeId) => {
  const response = await apiConfig.get(`${API_BASE}/employee/${employeeId}`);
  return response.data;
};

/** Valores mensualizados para el motor ISR. */
export const getTaxBenefitsForISR = async (employeeId, fiscalYear) => {
  const qs = fiscalYear ? `?fiscalYear=${fiscalYear}` : '';
  const response = await apiConfig.get(`${API_BASE}/isr/${employeeId}${qs}`);
  return response.data;
};

/** Catálogo de tipos de beneficios. */
export const getTaxBenefitTypes = async () => {
  const response = await apiConfig.get(`${API_BASE}/types`);
  return response.data;
};

/** Crear nuevo beneficio fiscal. */
export const createTaxBenefit = async (data) => {
  const response = await apiConfig.post(API_BASE, data);
  return response.data;
};

/** Actualizar beneficio fiscal. */
export const updateTaxBenefit = async (id, data) => {
  const response = await apiConfig.put(`${API_BASE}/${id}`, data);
  return response.data;
};

/** Eliminar beneficio fiscal. */
export const deleteTaxBenefit = async (id) => {
  const response = await apiConfig.delete(`${API_BASE}/${id}`);
  return response.data;
};
